export const focusAreas = [
  {
    title: 'Climate Adaptive Agriculture',
    desc: 'Building resilient, regenerative, and sustainable agriculture for the future.',
    gradient: 'rgba(82,183,136,.2)',
    delay: 'd1',
    iconType: 'agriculture',
  },
  {
    title: 'Living Income',
    desc: 'Empowering communities with fair wages and sustainable livelihood opportunities.',
    gradient: 'rgba(176,125,59,.2)',
    delay: 'd2',
    iconType: 'income',
  },
  {
    title: 'Healthy Planet',
    desc: 'Promoting health and sustainability for people and the planet.',
    gradient: 'rgba(82,183,136,.2)',
    delay: 'd3',
    iconType: 'planet',
  },
  {
    title: 'Greening Landscape',
    desc: 'Creating sustainable green spaces in rural and urban landscapes.',
    gradient: 'rgba(82,183,136,.2)',
    delay: 'd4',
    iconType: 'landscape',
  },
];
